import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=ab8e6008&scoped=true"
import script from "./messageInfo.vue?vue&type=script&lang=js"
export * from "./messageInfo.vue?vue&type=script&lang=js"
import style0 from "./messageInfo.vue?vue&type=style&index=0&id=ab8e6008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8e6008",
  null
  
)

export default component.exports